import FilterConstants from '../filter-constants';
import * as Format from './format';

let filterType = function (filterType, intl, overrideLocale) {
  return intl
    .t('panel.display-context.filter-type.' + filterType, { locale: overrideLocale ? overrideLocale : intl.locale })
    .toString();
};

let specificationsChoices = function (input, intl, overrideLocale) {
  return intl.t('annotations.filterResponse.orders.order' + input.nthOrder, {
    responseType: intl.t('annotations.filterResponse.responseType.' + input.responseType, {
      locale: overrideLocale ? overrideLocale : intl.locale,
    }),
    locale: overrideLocale ? overrideLocale : intl.locale,
  });
};

let signalFrequency = function (value, intl, signal, overrideLocale) {
  return intl.t('panel.display-context.frequency', {
    value: Format.formatFieldValue(value, FilterConstants.fieldTypes.Engineering, '3s'),
    signal: signal,
    locale: overrideLocale ? overrideLocale : intl.locale,
  });
};

let filterResponse = function (input) {
  let isChebyshev = input.selectedResponseType === FilterConstants.responseType.chebyshev;
  return input.filterResponseValue
    ? ' ' + input.filterResponseValue + (isChebyshev ? FilterConstants.gainUnits.db : '')
    : '';
};

let componentChoices = function (input, intl, overrideLocale) {
  const optimizationKeys = {
    Noise: 'panel.display-context.optimizations.noise',
    VoltageRange: 'panel.display-context.optimizations.voltage-range',
    Power: 'panel.display-context.optimizations.power',
  };
  let optimizationKey = optimizationKeys[input.optimization];
  if (FilterConstants.optimizationPreferenceOptions.specific === input.optimizationPreference) {
    optimizationKey = 'panel.display-context.optimizations.specific-components';
  }
  let componentChoices = intl
    .t('panel.display-context.components', {
      optimization: intl.t(optimizationKey, { locale: overrideLocale ? overrideLocale : intl.locale }),
      vplus: input.vsPlus,
      vminus: input.vsMinus,
      locale: overrideLocale ? overrideLocale : intl.locale,
    })
    .toString();
  return componentChoices;
};

let compensateForGBW = function (input, intl, overrideLocale) {
  return input.compensateForGbw
    ? intl
        .t('panel.display-context.compensate-gbw', { locale: overrideLocale ? overrideLocale : intl.locale })
        .toString()
    : '';
};

let toleranceChoices = function (input, intl, hasInductors, overrideLocale) {
  let toleranceChoices = intl
    .t('panel.display-context.tolerances', {
      rtolerance: input.resistorTolerance,
      ctolerance: input.capacitorTolerance,
      locale: overrideLocale ? overrideLocale : intl.locale,
    })
    .toString();
  return (
    toleranceChoices +
    (hasInductors
      ? '; ' +
        intl
          .t('panel.display-context.tolerances-inductor', {
            ltolerance: input.inductorTolerance,
            locale: overrideLocale ? overrideLocale : intl.locale,
          })
          .toString()
      : '')
  );
};

export function filterSummary(model, intl, overrideLocale) {
  let result = '';
  if (model.name) {
    result = filterType(model.name, intl, overrideLocale);
  }
  return result;
}

export function specificationsSummary(model, intl, overrideLocale) {
  let passbandFrequencyLabel = intl
    .t('panel.display-context.passband-frequency', { locale: overrideLocale ? overrideLocale : intl.locale })
    .toString();
  let centerFrequency = '';
  if (model.filter.name === FilterConstants.filterType.bandPass) {
    let centerFrequencyLabel = intl
      .t('panel.display-context.center-frequency', { locale: overrideLocale ? overrideLocale : intl.locale })
      .toString();
    centerFrequency =
      '; ' + signalFrequency(model.specificationsInput.centerFrequency, intl, centerFrequencyLabel, overrideLocale);
  }
  return (
    this.filterSummary(model.filter, intl, overrideLocale) +
    '; ' +
    specificationsChoices(model, intl, overrideLocale) +
    filterResponse(model.specificationsInput, overrideLocale) +
    '; ' +
    signalFrequency(model.specificationsInput.passbandFrequency, intl, passbandFrequencyLabel, overrideLocale) +
    centerFrequency
  );
}

export function componentsSummary(model, intl, overrideLocale) {
  return (
    this.specificationsSummary(model.specifications, intl, overrideLocale) +
    '; ' +
    componentChoices(model.componentsInput, intl, overrideLocale) +
    compensateForGBW(model.componentsInput, intl, overrideLocale)
  );
}

export function tolerancesSummary(model, intl, overrideLocale) {
  const hasInductors = model.components.actualStages.some((item) => {
    return item.selectedImplementation === FilterConstants.implementationType.inductor;
  });
  const componentsSummary = this.componentsSummary(model.components, intl, overrideLocale);
  const toleranceChoiceSummary = model.toleranceInput
    ? toleranceChoices(model.toleranceInput, intl, hasInductors, overrideLocale)
    : '';
  return componentsSummary + '; ' + toleranceChoiceSummary;
}
